import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, unref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router'

import ContractWriter from '../components/0_ContractWriter.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { query } = useRoute()

const loading = ref(false)
const writerRef = ref<ComponentRef<typeof ContractWriter>>()

onMounted(() => {
    unref(writerRef)?.methods.setFormData(query.contractId as string)
})


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(ContractWriter, {
    ref_key: "writerRef",
    ref: writerRef,
    "is-preview": true,
    showprogress: true,
    titles: `合同详细`
  }, null, 512)), [
    [_directive_loading, loading.value]
  ])
}
}

})